// extracted by mini-css-extract-plugin
export default {"formHeading":"nH-z","form":"oH-z","submitBtn":"pH-z","disabled":"qH-z","input":"rH-z","error":"sH-z","submitMsg":"tH-z","signIn":"uH-z"};